import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers/rootReducer";

export const useStore = () => {
  const authState = (state: RootState) => state.auth;
  const mrzState = (state: RootState) => state.scanMrz;
  const alertState = (state: RootState) => state.alertGlobal;
  const cameraState = (state: RootState) => state.camera;
  const pendingRequestState = (state: RootState) => state.pendingRequest;
  const dataState = (state: RootState) => state.data;
  const configState = (state: RootState) => state.config;
  const tabState = (state: RootState) => state.tabs;
  const exitState = (state: RootState) => state.exits;
  const authStore = useSelector(authState);
  const mrzStore = useSelector(mrzState);
  const alertStore = useSelector(alertState);
  const cameraStore = useSelector(cameraState);
  const pendingRequestStore = useSelector(pendingRequestState);
  const dataStore = useSelector(dataState);
  const configStore = useSelector(configState);
  const tabStore = useSelector(tabState);
  const registerExitStore = useSelector(exitState);
  return {
    authStore,
    mrzStore,
    alertStore,
    cameraStore,
    pendingRequestStore,
    dataStore,
    configStore,
    tabStore,
    registerExitStore,
  };
};
